<template>
  <div v-for="(child, i) in children" :key="i">
    <UiText
      v-if="child.type === NodeType.TEXT"
      :class="[
        { 'font-bold': child.bold },
        { italic: child.italic },
        { 'line-through': child.strikethrough },
        { underline: child.underline },
      ]"
      :styled="child.code"
    >
      {{ child.text }}
    </UiText>
    <UiLink v-if="child.type === NodeType.LINK" :id="`rich-text-${i}`" :to="child.url">
      {{ child.url }}
    </UiLink>
  </div>
</template>

<script setup lang="ts">
import type { RichTextContentParagraphProps } from '~/components/ui/RichTextContent/types';

import { NodeType } from '~/stores/cms/types';

defineProps<RichTextContentParagraphProps>();
</script>
